import { StoreEnvironment } from '../../Types/StoreTypes';

export const SET_BASE_PROMPT = 'SET_BASE_PROMPT';
export const SET_VISION_PROMPT = 'SET_VISION_PROMPT';
export const SET_SELECTED_PROMPT = 'SET_SELECTED_PROMPT';
export const SET_SHOW_USER_STATISTICS = 'SET_SHOW_USER_STATISTICS';
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';
export const SET_WINDOW_BREAKPOINT = 'SET_WINDOW_BREAKPOINT';
export const SET_DEMO_INSTANCE = 'SET_DEMO_INSTANCE';
export const SET_IS_CTRL_OR_CMD_PRESSED = 'SET_IS_CTRL_OR_CMD_PRESSED';
export const SET_CURRENT_URL = 'SET_CURRENT_URL';
export const SET_CURRENT_CHAT_ID = 'SET_CURRENT_CHAT_ID';
export const SET_COMBINED_PROMPTS = 'SET_COMBINED_PROMPTS';
export const SET_IS_DRAG_ACTIVE = 'SET_IS_DRAG_ACTIVE';
export const SET_DRAG_ZONE_ROOT_PROPS = 'SET_DRAG_ZONE_ROOT_PROPS';
export const SET_DRAG_ZONE_INPUT_PROPS = 'SET_DRAG_ZONE_INPUT_PROPS';
export const SET_SOURCE_CONTAINER_STATE = 'SET_SOURCE_CONTAINER_STATE';
export const SET_USER_PROMPTS = 'SET_USER_PROMPTS';
export const SET_LIST_RELOAD_TYPE = 'SET_LIST_RELOAD_TYPE';
export const SET_CHATLIST_CLEAR = 'SET_CHATLIST_CLEAR';
export const SET_RELOAD_PROMPTS = 'SET_RELOAD_PROMPTS';

export function setBasePrompt(basePrompt: StoreEnvironment['basePrompt']) {
    return { type: SET_BASE_PROMPT, payload: basePrompt };
}

export function setVisionPrompt(visionPrompt: StoreEnvironment['visionPrompt']) {
    return { type: SET_VISION_PROMPT, payload: visionPrompt };
}

export function setSelectedPrompt(selectedPrompt: StoreEnvironment['selectedPrompt']) {
    return { type: SET_SELECTED_PROMPT, payload: selectedPrompt };
}

export function setShowUserStatistics(showUserStatistics: StoreEnvironment['showUserStatistics']) {
    return { type: SET_SHOW_USER_STATISTICS, payload: showUserStatistics };
}

export function setWindowWidth(width: StoreEnvironment['windowWidth']) {
    return { type: SET_WINDOW_WIDTH, payload: width };
}

export function setWindowBreakpoint(breakpoint: StoreEnvironment['windowBreakpoint']) {
    return { type: SET_WINDOW_BREAKPOINT, payload: breakpoint };
}

export function setDemoInstance(demoInstance: StoreEnvironment['demoInstance']) {
    return { type: SET_DEMO_INSTANCE, payload: demoInstance };
}

export function setIsCtrlOrCmdPressed(isCtrlOrCmdPressed: StoreEnvironment['isCtrlOrCmdPressed']) {
    return { type: SET_IS_CTRL_OR_CMD_PRESSED, payload: isCtrlOrCmdPressed };
}

export function setCurrentLocation(currentLocation: StoreEnvironment['currentURL']) {
    return { type: SET_CURRENT_URL, payload: currentLocation };
}

export function setCurrentChatId(currentChatId: StoreEnvironment['currentChatId']) {
    return { type: SET_CURRENT_CHAT_ID, payload: currentChatId };
}

export function setCombinedPrompts(combinedPrompts: StoreEnvironment['combinedPrompts']) {
    return { type: SET_COMBINED_PROMPTS, payload: combinedPrompts };
}

export function setIsDragActive(isDragActive: StoreEnvironment['isDragActive']) {
    return { type: SET_IS_DRAG_ACTIVE, payload: isDragActive };
}

export function setDragZoneRootProps(dragZoneRootProps: StoreEnvironment['dragZoneRootProps']) {
    return { type: SET_DRAG_ZONE_ROOT_PROPS, payload: dragZoneRootProps };
}

export function setDragZoneInputProps(dragZoneInputProps: StoreEnvironment['dragZoneInputProps']) {
    return { type: SET_DRAG_ZONE_INPUT_PROPS, payload: dragZoneInputProps };
}

export function setSourceContainerState(sourceContainerState: StoreEnvironment['sourceContainerState']) {
    return { type: SET_SOURCE_CONTAINER_STATE, payload: sourceContainerState };
}

export function setUserPrompts(userPrompts: any) {
    return { type: SET_USER_PROMPTS, payload: userPrompts };
}

export function setListReloadType(listReloadType: StoreEnvironment['listReloadType']) {
    return { type: SET_LIST_RELOAD_TYPE, payload: listReloadType };
}

export function setChatlistClear(chatlistClear: StoreEnvironment['chatlistClear']) {
    return { type: SET_CHATLIST_CLEAR, payload: chatlistClear };
}

export function setReloadPrompts(reloadPrompts: StoreEnvironment['reloadPrompts']) {
    return { type: SET_RELOAD_PROMPTS, payload: reloadPrompts };
}
// export function setUserPrompts(userPrompts: StoreEnvironment['userPrompts']) {
//     return { type: SET_USER_PROMPTS, payload: userPrompts };
// }
